/**
 * This app composes no host. dink-api is same-origin at `/api`; every absolute
 * origin comes from bootstrap.
 *
 * Kept as a function, not a constant, so tests can re-stub `location` per test
 * and callers retain their existing shape even though the value is constant.
 */
export const API_PREFIX = '/api';

export function apiBase(): string {
  return API_PREFIX;
}
